import React, { useRef } from 'react';

import ModalAiArtist from './ModalAiArtist';

import DavidCImg from '../../../../../Images/gallery/ai-services/david-c.png';
import Video1 from '../../../../../Images/gallery/ai-services/david-c/video-1.png';
import Video2 from '../../../../../Images/gallery/ai-services/david-c/video-2.png';
import Video3 from '../../../../../Images/gallery/ai-services/david-c/video-3.png';

import {
  DavidC_Title,
  DavidC_Text,
  DavidC_Video1,
  DavidC_Video2,
  DavidC_Video3,
} from '../../../../../utils/EN/Modals/aiArtists';

const ModalDavidC = () => {
  return (
    <>
      <ModalAiArtist
        id="artist-david-c"
        artistImage={DavidCImg}
        artistName="David C"
        artistTitle={DavidC_Title}
        artisText={DavidC_Text}
        videoRef1={'david-video-1'}
        videoBg1={Video1}
        videoText1={DavidC_Video1}
        videoRef2={'david-video-2'}
        videoBg2={Video2}
        videoText2={DavidC_Video2}
        videoRef3={'david-video-3'}
        videoBg3={Video3}
        videoText3={DavidC_Video3}
      />
    </>
  );
};

export default ModalDavidC;
